import "./styles.css";
import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router";
import ComplienceEngine from './component/ComplienceEngine';
import BullsEyes from './component/BullsEyes';
import VAutomate from './component/VAutomate';
import Observer from './component/Observer';
import Home from './component/home'
import About from "./component/about";
import ContactPage from "./component/contactPage";
// import NoPageFound from './pageNotFound'
import MeetExpert from './component/meetExpert';
import Header from "./component/header";
import Services from './component/services';
import Resources from './component/resources';
import Termofuse from './component/termofuse';
import CaseStudy from './component/caseStudy';
import DownloadFile from "./component/downloadFile";
import QueryForm from "./component/queryForm";
import PageNotFound from "./pages/Components/pageNotFound";


export default function App(props) {
  return (
    <div className="App">
      <Header />
      <Routes>
      
        <Route path="/" exact element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/contact" element={<ContactPage/>} />
        <Route path="/meet-expert" element={<MeetExpert/>} />
        <Route path="/compliance-engine" element={<ComplienceEngine/>} />
        <Route path="/bullseye" element={<BullsEyes/>} />
        <Route path="/vAutomate" element={<VAutomate/>} />
        <Route path="/observer" element={<Observer/>} />
        <Route path="/services" element={<Services/>} />
        <Route path="/brochure" element={<Resources/>} />
        <Route path="/termofuse" element={<Termofuse/>} />
        <Route path="/successstories" element={<CaseStudy/>} />
        <Route path="/downloadfile" element={<DownloadFile />} />
        <Route path="/query-form" element={<QueryForm />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}
